import React from 'react';
import parse from 'html-react-parser';
import ReactGA from 'react-ga4';

import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { v4 } from 'uuid';
import { Checkbox, Alert, Spin } from 'antd';
import { CheckboxChangeEventTarget } from 'antd/lib/checkbox/Checkbox';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { get, isEmpty } from 'lodash';

import {
  buildCertificateContextWithPersistedFallback,
  GetWalletNumber,
  mergeHotelCertificateRouteHint,
  RootState,
  computeIsStripePaymentMethodsEnabled,
  getPreferenceFromAccount,
  getToken,
  isCertificateApplied,
  isDisplayCertificates,
  isInsuranceBookingSelectionMissing,
  isEnableCreditLine,
  roundMoney2,
  dollarsToStripeCents,
  GetEffectiveClientCashPercentage,
} from '@share/utils';
import {
  IReviewBookState,
  getBookPackageWithCard,
  setGuests,
  ICouponState,
  setPriceChangedError,
  InsuranceSelection,
  IInsuranceState,
  insuranceActions,
  refreshInsuranceQuote,
  setCard,
} from '@store/slices';
import {
  getNavigationMenu,
  ICertificatesState,
  IFiltersState,
  IHotelsState,
  ILoginState,
  IMenuState,
} from '@share/store/slices';
import { BlueButton, Loading } from '@share/components';
import { IBookPackageWithCard, ICardBooking, IFormErrors, IGuestsBooking, ScrollBehaviorEnum } from '@common-types';
import { IAccount, ISessionKey, ItemTypeEnum, LOGOUT_FIELD_KEY } from '@share/common-types';
import { UrlUtils, getSessionObj, renderNumber, getHotelRoutePath, getHotelIdFromPath, getSelectedCurrency, isValidEmail, LoginType, getCurrencyText } from '@share/utils';
import { DEFAULT_GUEST_DATA, NON_REFUNDABLE_TYPE } from '@constants';
import { ReservationProgress, BookingConfirmed, BookingFailed, ReviewBookPriceChangeModal, AvailabilityStatusModal, ExpiredSessionModal, ModalMessage, ThreeDSModal, ModalConfirmation, Insurance, InsuranceRequiredMessage } from '@components';
import { SESSION_KEY_LABEL_ROOMS, SESSION_KEY_LABEL, C_COMPLETE_BOOKING, C_PP, C_TERMS, USER_BASE_URL, QUOTE_LABEL, Routes, SESSION_KEY_TOKEN_NAME_PARAM, LIFE_STYLE_NAME_PARAM } from '@share/constants';
import { HOTEL_PACKAGE_ID } from '@constants';
import { IMarginatorState, setLoginRedirect } from '@share/store/slices';

import type { IMultiplePayments } from '../types';
import { GuestInfo } from '../guest-info-wrapper/guest-info';
import { WhiteButton } from '../../../common/white-button';
import { PaymentMethod } from '../payment-method';
import { ConfirmationEmail } from '../confirmation-email';
import { CancellationPolicies } from '../cancellation-policies';

import { GetPreferenceValue, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY } from '@utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import './style.scss';
import { Elements } from '@stripe/react-stripe-js';
import ExpressCheckoutButtons from '../../../../../share/components/express-checkout-buttons/component';
import ForceFullStripeCheckout from '../../../../../share/components/express-checkout-buttons/force-full-section/component';
import StripeCheckoutButtons from '../../../../../share/components/express-checkout-buttons/stripe-checkout-buttons/component';
import { StripeBtnTypes, stripePromise } from '../../../../../share/utils/stripe';
import GlobalLoading from '../../../../../share/components/global-spinner/component';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  redeemCodeStore: ICouponState;
  marginatorStore: IMarginatorState;
  hotelsStore: IHotelsState;
  filtersStore: IFiltersState;
  loginStore: ILoginState;
  insuranceStore: IInsuranceState;
  certificatesStore: ICertificatesState;
  navigationMenuStore: IMenuState;
}

interface IMapDispatchToProps {
  getBookPackageWithCard: (bookWithCard: IBookPackageWithCard) => void;
  setGuests: (guests: IGuestsBooking[]) => void;
  setPriceChangedError: (priceChanged: boolean) => void;
  getNavigationMenu: () => void;
  setLoginRedirect: (redirect: string) => void;
  setInsuranceSelection: (selection: InsuranceSelection | null) => void;
  setCard: (card: ICardBooking) => void;
  refreshInsuranceQuote: (state: string) => void;
  resetInsurance: () => void;
}

interface IProps
  extends IMapStateToProps,
  IMapDispatchToProps,
  WrappedComponentProps,
  RouteComponentProps {
  isVacationRentals: boolean;
  isRoomUnavaliableError?: boolean;
  certificateId?: string;
}

export interface IButtonsComplete {
  guestForm: boolean;
  emailForm: boolean;
  paymentForm: boolean;
}

interface IState {
  isAccept: boolean;
  isAcceptNoChangesAllowed: boolean;
  isAcceptBookingRemarks: boolean;
  isAcceptCancellationPolicy: boolean;
  isCheckMainGuest: boolean;
  isClientCash: boolean;
  isClientCashNotRefundable: boolean;
  isReward: boolean;
  isAcceptIsPackage: boolean;
  isAcceptIsInsurance: boolean;
  isSessionExpired: boolean;
  showNotRefundableMessage: boolean;
  showNotRefundableConfirmModal: boolean;
  isButtonCompleteHidden: IButtonsComplete;
  multiplePayments: IMultiplePayments;
  paymentSelected: string;
  scrollToPaymentSelect: boolean;
  ifEmailChanging: string | undefined;
  expressWalletProbeComplete: boolean;
  hasExpressWalletMethods: boolean;
  /** Two-step checkout when Stripe express is suppressed (force full Stripe). */
  forceFullStripeCheckoutPhase: 'details' | 'payment';
  /** Payment type the user is switching to from card while insurance is offered; drives the confirmation modal. */
  pendingPaymentSwitch: string | null;
  /** Force-full insurance flow: true while the guest still has to complete the insurance step (country/state/accept-decline). */
  forceFullInsuranceStepBlocked: boolean;
  /** Force-full insurance flow: flag empty residency selectors in red once the guest clicks "View Fields". */
  showInsuranceResidencyErrors: boolean;
  /** Force-full insurance flow: residency selection, owned here so it survives the details↔payment phase switch. */
  insuranceResidencyCountry: string;
  insuranceResidencyState: string;
}

const ZERO = 0;
const TEN_SEC = 10000;

const STRIPE_EXPRESS_PROBE_SR_ONLY: React.CSSProperties = {
  position: 'fixed',
  left: 0,
  top: 0,
  width: 'min(100vw, 480px)',
  height: 52,
  opacity: 0,
  pointerEvents: 'none',
  zIndex: -1,
  overflow: 'hidden',
};

class ReviewBookComponent extends React.Component<IProps, IState> {
  onExpressWalletAvailabilityResolved = (hasWallets: boolean) => {
    this.setState({
      expressWalletProbeComplete: true,
      hasExpressWalletMethods: hasWallets,
    });
  };
  state: IState = {
    isAccept: false,
    isAcceptBookingRemarks: false,
    isAcceptNoChangesAllowed: false,
    isAcceptCancellationPolicy: false,
    isCheckMainGuest: true,
    isClientCash: false,
    isClientCashNotRefundable: false,
    isReward: false,
    isAcceptIsPackage: false,
    isAcceptIsInsurance: false,
    isSessionExpired: false,
    showNotRefundableMessage: false,
    showNotRefundableConfirmModal: false,
    isButtonCompleteHidden: {
      guestForm: false,
      emailForm: false,
      paymentForm: false
    },
    multiplePayments: {
      amazonPay: false,
      applePay: false,
      googlePay: false,
      link: false,
      paypal: false
    },
    paymentSelected: '',
    scrollToPaymentSelect: false,
    ifEmailChanging: undefined,
    expressWalletProbeComplete: false,
    hasExpressWalletMethods: false,
    forceFullStripeCheckoutPhase: 'details',
    pendingPaymentSwitch: null,
    forceFullInsuranceStepBlocked: true,
    showInsuranceResidencyErrors: false,
    insuranceResidencyCountry: '',
    insuranceResidencyState: '',
  };

  formPaymentRef = React.createRef<FormInstance>();
  formGuestRef = React.createRef<FormInstance>();
  formEmailRef = React.createRef<FormInstance>();

  insuranceContainerRef = React.createRef<HTMLDivElement>();

  onChangeAccept = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAccept: e.target.checked });
  };

  onChangeAcceptBookingRemarks = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptBookingRemarks: e.target.checked });
  };

  onChangeAcceptKnowBeforeYouGo = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptNoChangesAllowed: e.target.checked });
  };

  onChangeAcceptCancellationPolicy = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptCancellationPolicy: e.target.checked });
  };

  onChangeAcceptIsPackage = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptIsPackage: e.target.checked });
  };

  onChangeAcceptIsInsurance = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isAcceptIsInsurance: e.target.checked });
  };

  onChangeAcceptClientCash = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isClientCash: e.target.checked });
  };

  onChangeAcceptClientCashNotRefundable = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({
      isClientCashNotRefundable: e.target.checked,
      showNotRefundableMessage: e.target.checked,
    });
  };

  onChangeAcceptReward = (e: { target: CheckboxChangeEventTarget }): void => {
    this.setState({ isReward: e.target.checked });
  };

  getGuests = () => {
    return this.props.reviewBookStore.bookingSummary?.bookingCard?.package?.rooms?.map((room, index) => {
        const guests = [...new Array(room.adultsCount)].map((_, indexGuest) => {
          return indexGuest === ZERO
            ? {
              ...DEFAULT_GUEST_DATA,
              id: v4(),
              isMainGuest: index === ZERO && indexGuest === ZERO,
              allocation: room.id,
              type: 'adult',
            }
            : {
              ...DEFAULT_GUEST_DATA,
              id: v4(),
              allocation: room.id,
              type: 'adult',
            };
        }) ?? [];

        const kids = room.kidsAges?.map((kidAge) => {
          return {
            ...DEFAULT_GUEST_DATA,
            id: v4(),
            allocation: room.id,
            type: 'kid',
            age: kidAge,
          };
        }) ?? [];

        return [...guests, ...kids];
      })
      .flat();
  };

  /** Force-full Stripe: return to the details page, keeping every prior selection. The acknowledgment
   *  checkboxes are controlled (`checked` bound to state) and the insurance selection is restored from
   *  the quote in the store, so nothing has to be re-entered. */
  handleForceFullBackToDetails = () => {
    this.setState({ forceFullStripeCheckoutPhase: 'details' });
  };

  handleOnCompleteBooking = () => {
    const { reviewBookStore, loginStore } = this.props;
    const { account, userWallet } = loginStore;
    const { bookingSummary, selectedHotelReviewClientCash, bookingComplete, booking } =
      reviewBookStore;
    const { refundability } = bookingSummary.bookingCard?.package;

    const hasClientCash = account?.hasClientCash;
    const walletIsExternal = account?.walletIsExternal;
    const walletSkipNonRefundable = account?.walletSkipNonRefundable;
    const isLogged = !!userWallet;

    const usedClientCash =
      bookingComplete && booking ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;

    const refundabilityFinal =
      !walletSkipNonRefundable &&
        !walletIsExternal &&
        hasClientCash &&
        isLogged &&
        (selectedHotelReviewClientCash > 0 || usedClientCash > 0)
        ? NON_REFUNDABLE_TYPE
        : refundability;

    if (NON_REFUNDABLE_TYPE === refundabilityFinal) {
      this.setState({ showNotRefundableConfirmModal: true });
    } else {
      this.onCompleteBooking();
    }
  };

  onCompleteBooking = () => {
    const { reviewBookStore, hotelsStore, loginStore } = this.props;
    const {
      isAcceptBookingRemarks,
      isAccept,
      isAcceptCancellationPolicy,
      isAcceptNoChangesAllowed,
    } = this.state;
    const {
      bookingSummary,
      card,
      guests,
      loadingBooking,
      isSoldOutError,
      selectedHotelReviewClientCash,
    } = reviewBookStore;
    const { referenceNumber, agencyNumber } = hotelsStore;
    const { account, userWallet, userWalletData } = loginStore;
    const { balance } = bookingSummary.bookingCard;

    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;
    const certificateApplied = isCertificateApplied(
      account as IAccount,
      this.props.filtersStore.certificateId || this.props.certificateId,
    );

    const finalBalanceIntermediate = certificateApplied
      ? balance
      : balance - (selectedHotelReviewClientCash ? selectedHotelReviewClientCash * convertionRate : 0);
    const finalBalance = roundMoney2(finalBalanceIntermediate);

    const token = getToken(account as IAccount);
    const isPrivateWithToken = account?.type === LoginType.PrivateWithToken;

    if (isPrivateWithToken && !token) {
      this.setState({ isSessionExpired: true });
      return;
    }

    if (
      loadingBooking ||
      isSoldOutError ||
      !isAccept ||
      !isAcceptBookingRemarks ||
      !isAcceptCancellationPolicy ||
      !isAcceptNoChangesAllowed
    ) {
      return;
    }

    const { coupon } = this.props.redeemCodeStore;
    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );
    const getLeadPax = guests.find((guest) => guest.isMainGuest);

    if (getLeadPax === undefined) {
      this.setState({ isCheckMainGuest: false });
      window.scrollTo(ZERO, ZERO);
    }
    let quote;
    if (values[QUOTE_LABEL]) {
      quote = values[QUOTE_LABEL] as string;
    }

    const data: any = {
      sessionKey,
      bookingPrice: bookingSummary?.bookingCard.bookingPrice.payNowPrice,
      hotelId: bookingSummary?.bookingCard.package.hotelId,
      leadPaxId: getLeadPax?.id,
      leadPaxRoomId: getLeadPax?.allocation,
      packageId: bookingSummary?.bookingCard.package.packageId,
      guests: guests.map((guest) => {
        const type: string = guest?.type;

        return {
          ...guest,
          namePrefix: !isEmpty(guest?.namePrefix) ? guest?.namePrefix : 'Mr',
          givenName: !isEmpty(guest?.givenName) ? guest?.givenName : 'TBV',
          surname: !isEmpty(guest?.surname) ? guest?.surname : 'TBV',
          type,
        };
      }),
      referenceNumber,
      agencyNumber,
      currency: getSelectedCurrency(loginStore.account as IAccount),
      quote,
    };

    if (!certificateApplied) {
      data.couponCode = coupon;
      data.marginator = {
        percentage: this.props.marginatorStore.percentage,
        commission: this.props.marginatorStore.commission,
        impersonator: {
          memberId: this.props.marginatorStore.impersonator.memberId,
        },
      };
    }

    const privateTokenFromUrl = account?.privateTokenFromUrl;
    if (isPrivateWithToken && privateTokenFromUrl) {
      const ssoSessionKey = UrlUtils.getSearchParam(SESSION_KEY_TOKEN_NAME_PARAM);
      data.ssoSessionKey = ssoSessionKey;
      data.lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM);
    }

    const displayCertificates = isDisplayCertificates(this.props.loginStore.account as IAccount);
    if (displayCertificates) {
      const certificateHint = mergeHotelCertificateRouteHint(
        this.props.history.location.state,
        this.props.filtersStore,
      );
      const certificateContext = buildCertificateContextWithPersistedFallback({
        certificateId: certificateHint?.certificateId || this.props.certificateId,
        certificateItemId: certificateHint?.certificateItemId,
        certificates: this.props.certificatesStore?.data,
        itemType: ItemTypeEnum.Hotel,
      });
      if (certificateContext) {
        data.certificateContext = certificateContext;
      }
    }

    const hasClientCash = account?.hasClientCash;
    const isLogged = !!userWallet;
    const skipPayment = isEnableCreditLine(account);

    if (!skipPayment) {
      const paymentMethod = { paymentMethodId: card?.id, CVC: card?.cvv };
      const creditCard = { ...card, phone: getLeadPax?.phone };

    if (!certificateApplied && hasClientCash && isLogged) {
      data.clientCashAmount = selectedHotelReviewClientCash ? selectedHotelReviewClientCash : 0;

        if (finalBalance > 0) {
          if (!isEmpty(card?.id)) {
            data.paymentMethod = paymentMethod;
          } else {
            data.card = creditCard;
          }
        }
      } else {
        if (!isEmpty(card?.id)) {
          data.paymentMethod = paymentMethod;
        } else {
          data.card = creditCard;
        }
      }
    } else if (hasClientCash && isLogged) {
      data.clientCashAmount = selectedHotelReviewClientCash ? selectedHotelReviewClientCash : 0;
    }

    this.setFieldsGuestsValue(guests);
    this.formEmailRef.current?.setFieldsValue({ email: this.mainGuestData('email') });
    this.formGuestRef.current?.setFieldsValue({
      mainGuestGivenName: this.mainGuestData('givenName'),
    });
    this.formGuestRef.current?.setFieldsValue({
      mainGuestPhone: this.mainGuestData('phone'),
    });
    this.formGuestRef.current?.setFieldsValue({ mainGuestSurname: this.mainGuestData('surname') });
    if (!skipPayment) {
      this.formPaymentRef.current?.setFieldsValue({ address: card.addressLine });
      this.formPaymentRef.current?.setFieldsValue({ city: card.city });
      this.formPaymentRef.current?.setFieldsValue({ state: card.state });
      this.formPaymentRef.current?.setFieldsValue({ 'postal-code': card.zipCode });
    }

    const formPaymentRef = skipPayment ? undefined : this.formPaymentRef.current?.validateFields();
    const formGuestRef = this.formGuestRef.current?.validateFields();
    const formEmailRef = this.formEmailRef.current?.validateFields();

    ReactGA.event({
      category: account?.name as string,
      action: `${C_COMPLETE_BOOKING}_${account?.name.toUpperCase()}`,
      label: `User clicked complete booking on book`,
      nonInteraction: false,
    });

    Promise.all([formPaymentRef, formGuestRef, formEmailRef].filter(Boolean))
      .then(() => {
        this.props.getBookPackageWithCard(data);
      })
      .catch((error: IFormErrors) => {
        const { errorFields } = error;
        const { name } = errorFields[ZERO];

        const { scrollToField: scrollToPaymentField } = (this.formPaymentRef.current as any);
        const { scrollToField: scrollToGuestField } = (this.formGuestRef.current as any);
        const { scrollToField: scrollToEmailField } = (this.formEmailRef.current as any);

        (() => {
          scrollToEmailField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          scrollToPaymentField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          scrollToGuestField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
        })();
      });
  };

  setFieldsGuestsValue = (guests: IGuestsBooking[]): void[] => {
    return guests.map((guest, index) => {
      if (guest.isMainGuest === true) {
        return;
      }

      this.formGuestRef.current?.setFieldsValue({ [`guests[${index}].givenName`]: guest.givenName });
      this.formGuestRef.current?.setFieldsValue({ [`guests[${index}].surname`]: guest.surname });
    });
  };

  handleRedirect = () => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    const logoutUrlStorage = localStorage.getItem(USER_BASE_URL);
    const logoutPref = getPreferenceFromAccount(account as IAccount, LOGOUT_FIELD_KEY);
    const logoutUrl = !isEmpty(logoutUrlStorage) ? logoutUrlStorage : logoutPref;
    if (logoutUrl && !isEmpty(logoutUrl)) {
      window.location.replace(logoutUrl);
    }
  };

  mainGuestData = (item: string): string => {
    // `guests` is `null` before the booking-summary fetch resolves. We're now called from `render()`
    // (for the email-validity gate on the Complete button) so the first paint can hit this path
    // before any `guests` arrive — guard the find().
    const guests = this.props.reviewBookStore.guests;
    if (!Array.isArray(guests)) return '';
    const guest = guests.find((g) => g.isMainGuest === true);
    return guest ? (guest[item] as string) : '';
  };

  titleBookingFailed = (): string => {
    return `${this.props.intl.formatMessage({ id: 'your.booking.in' })}
      ${this.props.reviewBookStore.bookingSummary.bookingCard.name}
      ${this.props.intl.formatMessage({ id: 'did.not.go.through' })}`;
  };

  redirectToHotelPage = (): void => {
    const hotelId = getHotelIdFromPath(this.props.history);
    const hotelPath = getHotelRoutePath(hotelId, this.props.history);
    this.props.history.push(hotelPath);
    this.props.setPriceChangedError(false);
  };

  getErrorMessages = () => {
    const { errorsBookingMessage, stripeError } = this.props.reviewBookStore;
    if (!isEmpty(stripeError)) {
      return <p>{stripeError}</p>;
    } else {
      return errorsBookingMessage.map((message, index) => (
        <p key={index}>{message.errorMessage}</p>
      ));
    }
  };

  componentDidMount() {
    this.props.setGuests(this.getGuests());

    // Force-full Stripe: the insurance answer lives in a store that outlives this page, so a choice
    // made on an earlier checkout would come back pre-selected here. Every checkout starts unanswered.
    if (this.props.loginStore.account?.forceStripeFull) {
      this.props.setInsuranceSelection(null);
    }
  }

  componentDidUpdate(prevProps: Readonly<IProps>) {
    const { bookingComplete, errorBooking, bookingSummary } = this.props.reviewBookStore;
    const { bookingCard } = bookingSummary ?? {};

    if (
      (bookingComplete && bookingComplete !== prevProps.reviewBookStore.bookingComplete) ||
      (errorBooking && errorBooking !== prevProps.reviewBookStore.errorBooking)
    ) {
      localStorage.setItem(HOTEL_PACKAGE_ID, JSON.stringify(bookingCard.package.packageId));
      setTimeout(() => {
        this.props.getNavigationMenu();
      }, TEN_SEC);
    }

    const { account } = this.props.loginStore;
    const stripeRegionOk = computeIsStripePaymentMethodsEnabled(
      account,
      this.props.navigationMenuStore?.items?.siteId,
      this.props.navigationMenuStore?.items?.organizationId,
    );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    if (!suppressStripePaymentUI && this.state.forceFullStripeCheckoutPhase !== 'details') {
      this.setState({ forceFullStripeCheckoutPhase: 'details' });
    }

    this.syncForceFullResidencyFromCard();
  }

  /** True while the hotels full-Stripe insurance step is on screen (details phase). There the
   *  residency state is mirrored from the billing-address section rather than picked blind —
   *  mirrors the condo flow, which mirrors it from the primary-address section. */
  isForceFullDetailsInsuranceActive = (): boolean => {
    const { loginStore, navigationMenuStore, reviewBookStore } = this.props;
    const { account } = loginStore;
    const { card } = reviewBookStore;

    const stripeRegionOk =
      !isEnableCreditLine(account) &&
      computeIsStripePaymentMethodsEnabled(
        account,
        navigationMenuStore?.items?.siteId,
        navigationMenuStore?.items?.organizationId,
      );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    const forceFullInsuranceEnabled =
      suppressStripePaymentUI &&
      !!account?.enableInsurance &&
      !navigationMenuStore?.items?.isRemoveInsurance &&
      !card?.id;

    return forceFullInsuranceEnabled && this.state.forceFullStripeCheckoutPhase === 'details';
  };

  /** Last residency mirrored from the billing address, so the sync can tell an address edit from a
   *  state the guest picked by hand in the insurance box. Residency and billing are allowed to
   *  differ — the address only seeds the dropdown, it does not own it — so a manual pick must not
   *  be reverted by the next unrelated update. */
  lastDerivedResidency: { country: string; state: string } | null = null;

  /** Keep the insurance residency (and its quote) in step with the billing-address section while the
   *  hotels full-Stripe insurance step is shown. Only acts when the *address* changed, so it won't
   *  loop on the quote's own store updates and won't overwrite a manual pick. The card already holds
   *  ISO country codes and USA_STATES postal codes, so no mapping is needed. */
  syncForceFullResidencyFromCard = () => {
    if (!this.isForceFullDetailsInsuranceActive()) {
      return;
    }

    const { card } = this.props.reviewBookStore;
    const country = card?.country || '';
    const derived = {
      country,
      state: country === 'US' ? (card?.state || '').toUpperCase() : '',
    };
    const previous = this.lastDerivedResidency;
    const addressChanged =
      !!previous && (derived.country !== previous.country || derived.state !== previous.state);
    const differsFromSelection =
      derived.country !== this.state.insuranceResidencyCountry ||
      derived.state !== this.state.insuranceResidencyState;

    this.lastDerivedResidency = derived;

    if (!differsFromSelection || (previous && !addressChanged)) {
      return;
    }

    this.setState({
      insuranceResidencyCountry: derived.country,
      insuranceResidencyState: derived.state,
    });

    // A different rating state means a different price, so an answer given for the old quote no
    // longer applies — same rule the manual residency picker enforces.
    const previousSelection = this.props.insuranceStore?.selection;
    if (previousSelection !== null && previousSelection !== undefined) {
      this.props.setInsuranceSelection(null);
      this.setState({ isAcceptIsInsurance: false });
    }

    if (derived.country === 'US' && derived.state) {
      this.props.refreshInsuranceQuote(derived.state);
    } else {
      this.props.resetInsurance();
    }
  };

  hangleGoToLogin = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.Login}`);
  }

  hangleGoToSignUp = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.SignUp}`);
  }

  render(): React.ReactNode {
    const { isSessionExpired, showNotRefundableMessage } = this.state;
    const {
      reviewBookStore,
      loginStore,
      insuranceStore,
      navigationMenuStore,
      isVacationRentals,
      intl,
    } = this.props;
    const {
      card,
      guests,
      loadingBooking,
      bookingComplete,
      bookingSummary,
      isPriceChangedError,
      isSoldOutError,
      errorsBookingMessage,
      isBookingInProgress,
      threeDSLoading,
      selectedHotelReviewClientCash,
      stripeLoading,
      stripeError,
      rewardId,
    } = reviewBookStore;
    const { account, userWallet, userWalletData, userWalletReward } = loginStore;
    const { selection, insurance, loading: insuranceLoading, error: insuranceError } = insuranceStore;

    if (bookingComplete && (isEmpty(bookingSummary) || !bookingSummary)) {
      return (
        <>
          {isBookingInProgress && <ReservationProgress isBookingInProgress={isBookingInProgress} />}
          <BookingConfirmed
            isBookingComplete={bookingComplete}
            isVacationRentals={isVacationRentals}
            packageData={reviewBookStore}
          />
          <ModalConfirmation
            message="non.refundable.reservation.message"
            title="non.refundable.reservation"
            yesMessage="yes"
            noMessage="no"
            visible={this.state.showNotRefundableConfirmModal}
            onCancel={() => this.setState({ showNotRefundableConfirmModal: false })}
            onConfirm={() =>
              this.setState({ showNotRefundableConfirmModal: false }, this.onCompleteBooking)
            }
          />
          {isPriceChangedError && (
            <BookingFailed
              title={intl.formatMessage({ id: 'price.changed' })}
              description={intl.formatMessage({ id: 'unable.to.confirm.booking' })}
              buttonTitle={intl.formatMessage({ id: 'book.another.room' })}
              onClick={this.redirectToHotelPage}
              isPriceChangedError={isPriceChangedError}
              isVacationRentals={isVacationRentals}
            />
          )}
          {isSoldOutError && (
            <BookingFailed
              title={this.titleBookingFailed()}
              isVacationRentals={isVacationRentals}
              description={intl.formatMessage({ id: 'sorry.we.were.unable.to.confirm' })}
              buttonTitle={intl.formatMessage({ id: 'start.searching' })}
              onClick={this.redirectToHotelPage}
            />
          )}
          <ReviewBookPriceChangeModal isVacationRentals={isVacationRentals} />
          <AvailabilityStatusModal isVacationRentals={isVacationRentals} />
          <ThreeDSModal />
          {threeDSLoading ? (
            <div className="review-book__loading-container">
              <Loading />
            </div>
          ) : null}
          {isSessionExpired && (
            <div className="result-wrapper__expired-message">
              <ExpiredSessionModal
                visible={isSessionExpired}
                hasRedirect={true}
                onHandleRedirect={this.handleRedirect}
              />
            </div>
          )}
          <GlobalLoading isVisible={stripeLoading} />
        </>
      );
    }

    const isPackage = reviewBookStore.bookingSummary.bookingCard.package.isPackage;

    const isNotification =
      bookingComplete || isPriceChangedError || isSoldOutError || isBookingInProgress;

    const currency = bookingSummary?.bookingCard?.package?.currency;
    const { balance, bookingPrice } = bookingSummary.bookingCard;
    const { maxWalletClientCash } = bookingPrice;
    const { maxRewardWalletAmount } = bookingSummary.bookingCard.package ?? {};

    const chargeDescription = GetPreferenceValue(account as IAccount, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY);
    const walletNoPassEarnings = account?.walletNoPassEarnings;
    const walletNoDecimals = account?.walletNoDecimals;
    const walletIsExternal = account?.walletIsExternal;
    const walletSkipNonRefundable = account?.walletSkipNonRefundable;

    const hasClientCash = account?.hasClientCash;
    const effectiveClientCashPercentage = GetEffectiveClientCashPercentage(loginStore);
    const enableInsurance = account?.enableInsurance;
    const isLogged = !!userWallet;

    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;

    const balanceInt = balance;
    const maxWalletClientCashInt = maxWalletClientCash;

    const finalBalanceIntermediate =
      balanceInt -
      (selectedHotelReviewClientCash ? selectedHotelReviewClientCash : 0) * convertionRate;
    const finalBalance = roundMoney2(finalBalanceIntermediate);

    const certificateApplied = isCertificateApplied(
      account as IAccount,
      this.props.filtersStore.certificateId || this.props.certificateId,
    );
    const finalBalanceDisplay = roundMoney2(certificateApplied ? balanceInt : finalBalanceIntermediate);

    const eligibleClientCash =
      ((finalBalance > 0 ? finalBalance : 0) * effectiveClientCashPercentage) /
      100;
    const isRequired = !hasClientCash || finalBalance > 0;
    const balanceCalculated = balanceInt / convertionRate;

    const maxWalletClientCashCalculated = maxWalletClientCashInt ? walletNoDecimals ? Math.floor(maxWalletClientCashInt / convertionRate) : maxWalletClientCashInt / convertionRate : null;
    const userWalletDataBalanceCalculatedInt = (walletNoDecimals && userWalletData?.balance) ? Math.floor(userWalletData?.balance) : userWalletData?.balance;
    const userWalletDataBalanceCalculated = userWalletDataBalanceCalculatedInt ? userWalletDataBalanceCalculatedInt : 0;
    const maxWalletAmountIntermediated = walletNoPassEarnings ?
      maxWalletClientCashCalculated ?
        (maxWalletClientCashCalculated && userWalletDataBalanceCalculated > maxWalletClientCashCalculated) ?
          maxWalletClientCashCalculated :
          userWalletDataBalanceCalculated :
        0 :
      userWalletDataBalanceCalculated > balanceCalculated ?
        balanceCalculated :
        userWalletDataBalanceCalculated;

    const maxWalletAmount =
      maxWalletClientCashCalculated && maxWalletAmountIntermediated > maxWalletClientCashCalculated
        ? maxWalletClientCashCalculated
        : maxWalletAmountIntermediated;

    const clientCash = selectedHotelReviewClientCash ? GetWalletNumber(selectedHotelReviewClientCash, account as IAccount) : Number(0).toFixed(walletNoDecimals ? 0 : 2);

    const insuranceBalance =
      selection === InsuranceSelection.YES && !!insurance?.productDetails?.price
        ? insurance?.productDetails?.price
        : 0;
    const isInsuranceSelected =
      selection === InsuranceSelection.YES && !!insurance?.productDetails?.price;

    /** Same basis as room-info totalPayDisplay */
    const rewardDeductionExpress =
      rewardId && maxRewardWalletAmount && !bookingComplete ? maxRewardWalletAmount : 0;
    const expressChargeTotal = Math.max(
      0,
      finalBalance + insuranceBalance - rewardDeductionExpress,
    );
    const finalAmount = dollarsToStripeCents(expressChargeTotal);

    const skipPaymentCheckout = isEnableCreditLine(account);
    const stripeRegionOk =
      !skipPaymentCheckout &&
      computeIsStripePaymentMethodsEnabled(
        account,
        navigationMenuStore?.items?.siteId,
        navigationMenuStore?.items?.organizationId,
      );
    const suppressStripePaymentUI = stripeRegionOk && !!account?.forceStripeFull;
    const showExpressCheckoutFlow =
      !suppressStripePaymentUI &&
      stripeRegionOk &&
      this.state.expressWalletProbeComplete &&
      this.state.hasExpressWalletMethods;
    const paymentEffective = showExpressCheckoutFlow ? this.state.paymentSelected : 'card';

    const isCardPayment =
      !suppressStripePaymentUI &&
      !skipPaymentCheckout &&
      !isEmpty(paymentEffective) &&
      paymentEffective === 'card';
    const isForceFullStripePaymentStep =
      suppressStripePaymentUI && this.state.forceFullStripeCheckoutPhase === 'payment';
    const isCardPaymentEffective = isCardPayment || isForceFullStripePaymentStep;
    const showInsuranceGuestSection =
      !card?.id && !suppressStripePaymentUI && isCardPaymentEffective;

    // Force-full Stripe accounts can still sell insurance, but only via the legacy card path.
    // When insurance is enabled we offer it on the details page; choosing YES diverts checkout to
    // the legacy credit-card form (country locked to USA, state locked to the page-1 selection).
    const forceFullInsuranceEnabled =
      suppressStripePaymentUI &&
      !!enableInsurance &&
      !navigationMenuStore?.items?.isRemoveInsurance &&
      !card?.id;
    const forceFullDetailsInsurance =
      forceFullInsuranceEnabled && this.state.forceFullStripeCheckoutPhase === 'details';
    const forceFullLegacyCard =
      forceFullInsuranceEnabled &&
      !!insurance &&
      isEmpty(insuranceError) &&
      selection === InsuranceSelection.YES;
    // The guest must complete the insurance step before "go to payments": pick a country (and state
    // for the US), let the quote resolve, and explicitly accept/decline an available offer. The
    // Insurance component reports this via onResidencyStepChange. Only enforced in the details phase.
    const forceFullInsuranceBlocksNext =
      forceFullDetailsInsurance && this.state.forceFullInsuranceStepBlocked;

    const isInsuranceSelectionMissing = isInsuranceBookingSelectionMissing(
      showInsuranceGuestSection || forceFullDetailsInsurance,
      enableInsurance,
      insurance,
      insuranceLoading,
      insuranceError,
      navigationMenuStore?.items?.isRemoveInsurance,
      selection,
    );
    const isOtherPayment =
      showExpressCheckoutFlow &&
      !isEmpty(this.state.paymentSelected) &&
      this.state.paymentSelected !== 'card';

    const shouldMountStripeExpressElements =
      !suppressStripePaymentUI &&
      stripeRegionOk &&
      (!this.state.expressWalletProbeComplete || this.state.hasExpressWalletMethods);

    /**
     * Both Stripe modes drop the credit-card form, and that form was the only place the traveler's
     * address was ever collected. Re-render it here — same component, same spot — with the card
     * inputs stripped, so the address survives and goes out as the body's `billingAddress`:
     *   - express: a wallet (Apple/Google/Amazon Pay, Link, PayPal) is selected instead of 'card';
     *   - force-full: the details page, before handing over to Stripe's PaymentElement. When the
     *     guest opts into insurance the legacy card form takes over at the payment step and brings
     *     its own address block back, so this one only belongs to the details phase.
     */
    const showAddressOnlyForm =
      !skipPaymentCheckout &&
      finalBalanceDisplay > 0 &&
      (isOtherPayment ||
        (suppressStripePaymentUI && this.state.forceFullStripeCheckoutPhase === 'details'));

    const validateForm = () => {
      // Force-full insurance step incomplete (no country/state picked, quote loading, or offer not
      // yet accepted/declined): flag the residency selectors in red and scroll to them.
      if (forceFullInsuranceBlocksNext) {
        this.setState({ showInsuranceResidencyErrors: true });
        this.insuranceContainerRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        return;
      }
      if (isInsuranceSelectionMissing) {
        this.insuranceContainerRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
        return;
      }

      const formGuestRef = this.formGuestRef.current?.validateFields();
      const formEmailRef = this.formEmailRef.current?.validateFields();
      const formPaymentRef = this.formPaymentRef.current?.validateFields();
      let promises = [formGuestRef, formEmailRef];
      const shouldIncludePayment = (isCardPayment || showAddressOnlyForm) && !skipPaymentCheckout;

      if (shouldIncludePayment) {
        promises.push(formPaymentRef);
      } else {
        promises = [formGuestRef, formEmailRef];
      }

      if (showExpressCheckoutFlow && !skipPaymentCheckout && isEmpty(this.state.paymentSelected)) {
        this.setState({ scrollToPaymentSelect: true })
        const paymentSection = document.getElementById("payment-methods-select__card");
        if (paymentSection) {
          paymentSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        scrollToPaymentSelectDisabled();
      }

      Promise.all(promises)
        .catch((error: IFormErrors) => {
          const { errorFields } = error;
          const { name } = errorFields[0];

          const { scrollToField: scrollToGuestField } = this.formGuestRef.current ?? {};
          const { scrollToField: scrollToEmailField } = this.formEmailRef.current ?? {};

          scrollToGuestField?.(name[0], { behavior: ScrollBehaviorEnum.Smooth });

          scrollToEmailField?.(name[0], { behavior: ScrollBehaviorEnum.Smooth });

          if (shouldIncludePayment && this.formPaymentRef.current) {
            const { scrollToField: scrollToPaymentField } = this.formPaymentRef.current;
            scrollToPaymentField(name[0], { behavior: ScrollBehaviorEnum.Smooth });
          }
        });
    };

    const scrollToPaymentSelectDisabled = () => this.setState({ scrollToPaymentSelect: false });

    const handleGuestFormValidation = (guestForm: boolean): void => {
      this.setState((prevState: IState) => ({
        ...prevState,
        isButtonCompleteHidden: {
          ...prevState.isButtonCompleteHidden,
          guestForm,
        },
      }));
    };

    const handleEmailFormValidation = (emailForm: boolean): void => {
      this.setState((prevState: IState) => ({
        ...prevState,
        isButtonCompleteHidden: {
          ...prevState.isButtonCompleteHidden,
          emailForm,
        },
      }));
    };

    const handlePaymentFormValidation = (paymentForm: boolean): void => {
      this.setState((prevState: IState) => ({
        ...prevState,
        isButtonCompleteHidden: {
          ...prevState.isButtonCompleteHidden,
          paymentForm,
        },
      }));
    };

    // Guest/email sections unmount on force-full payment step — no form flags; payment step only confirms Stripe.
    // `showAddressOnlyForm` puts the billing-address block back on screen, so its validity counts too.
    const keysToValidate: Array<keyof IButtonsComplete> = isForceFullStripePaymentStep
      ? (forceFullLegacyCard ? ['paymentForm'] : [])
      : (isCardPaymentEffective && !suppressStripePaymentUI) || showAddressOnlyForm
        ? ['guestForm', 'emailForm', 'paymentForm']
        : ['guestForm', 'emailForm'];

    const showCompleteBookingButton = skipPaymentCheckout || isCardPayment;

    // Validate only the selected keys
    //VALIDATE THE SELECT PAYMENT FORM
    const formsStripeComplete = keysToValidate.every(
      (key) => this.state.isButtonCompleteHidden[key] === true,
    );
    const VALIDATE_STRIPE_BTNS =
      skipPaymentCheckout ||
      (!isEmpty(paymentEffective) && formsStripeComplete && !isInsuranceSelectionMissing);

    /** Block submission whenever the entered main-guest email is empty / malformed. Checked here
     *  (not only in the per-form `isButtonCompleteHidden.emailForm` flag) so it also gates the
     *  force-full phase-2 Complete button and the skipPaymentCheckout (credit-line) path, where
     *  the existing per-form check is bypassed. */
    const mainGuestEmail = this.mainGuestData('email');
    const isMainGuestEmailValid = isValidEmail(mainGuestEmail);

    /** "Please, fill in all required fields to proceed". `VALIDATE_STRIPE_BTNS` also folds in the
     *  insurance answer, which would make this generic line appear (and disappear) because of the
     *  insurance step. On the force-full details page insurance has its own message right below, so
     *  here the line reflects the guest/email forms only. */
    const showRequiredFieldsMessage = forceFullDetailsInsurance
      ? !skipPaymentCheckout && (!formsStripeComplete || !isMainGuestEmailValid)
      : !VALIDATE_STRIPE_BTNS;

    const isCardCompleteBookingDisabled =
      !VALIDATE_STRIPE_BTNS ||
      !isMainGuestEmailValid ||
      isSoldOutError ||
      (isPackage && account?.isTravelAgentPro && !this.state.isAcceptIsPackage) ||
      (!skipPaymentCheckout &&
        !shouldMountStripeExpressElements &&
        !card?.id &&
        showInsuranceGuestSection &&
        enableInsurance &&
        insurance &&
        (selection === null || selection === undefined)) ||
      (isInsuranceSelected && !this.state.isAcceptIsInsurance) ||
      forceFullInsuranceBlocksNext ||
      loadingBooking ||
      !this.state.isAccept ||
      !this.state.isAcceptBookingRemarks ||
      !this.state.isAcceptCancellationPolicy ||
      !this.state.isAcceptNoChangesAllowed ||
      (hasClientCash && isLogged && !this.state.isClientCash) ||
      (account?.enableWalletReward && isLogged && !this.state.isReward) ||
      (hasClientCash &&
        isLogged &&
        !this.state.isClientCashNotRefundable &&
        selectedHotelReviewClientCash > 0 &&
        !walletIsExternal &&
        !walletSkipNonRefundable) ||
      (hasClientCash && isLogged && selectedHotelReviewClientCash > maxWalletAmount) ||
      (hasClientCash &&
        isLogged &&
        !!selectedHotelReviewClientCash &&
        selectedHotelReviewClientCash <= maxWalletAmount &&
        walletNoDecimals &&
        Math.floor(selectedHotelReviewClientCash) !== selectedHotelReviewClientCash);

    const TWO = 2;

    const setMultiplePayments = (payments: any) => {
      this.setState((prevState: IState) => ({
        ...prevState,
        multiplePayments: {
          ...payments,
        },
      }));
    };

    const setPaymentSelected = (payment: string) => {
      const isLeavingCard =
        this.state.paymentSelected === 'card' && !isEmpty(payment) && payment !== 'card';
      const insuranceOffered =
        showInsuranceGuestSection &&
        !!enableInsurance &&
        !!insurance &&
        !navigationMenuStore?.items?.isRemoveInsurance;
      // Insurance only rides along with card payments. Warn before dropping it.
      if (isLeavingCard && insuranceOffered) {
        this.setState({ pendingPaymentSwitch: payment });
        return;
      }
      this.setState((prevState: IState) => ({
        ...prevState,
        paymentSelected: payment,
      }));
    };

    const isEmailChanging = (ifEmailChanging: string | undefined) => this.setState({ ifEmailChanging })

    return (
      guests && (
        <>
          {!bookingComplete && (
          <div
            className={`review-book ${isNotification ? 'hide-block' : ''}${
              suppressStripePaymentUI ? ' force-stripe-full-active' : ''
            }`}
          >
            {(errorsBookingMessage && errorsBookingMessage.length) || !isEmpty(stripeError) && (
              <Alert
                message={<FormattedMessage id="transaction.failed" />}
                description={this.getErrorMessages()}
                type="error"
                showIcon
              />
            )}

            {(!suppressStripePaymentUI ||
              this.state.forceFullStripeCheckoutPhase === 'details') && (
              <>
            <GuestInfo
              formRef={this.formGuestRef as React.RefObject<FormInstance>}
              isCheckMainGuest={this.state.isCheckMainGuest}
              handleGuestFormValidation={handleGuestFormValidation}
              emailRef={this.formEmailRef as React.RefObject<FormInstance>}
              isEmailChanging={isEmailChanging}
            />

            {bookingSummary.providerMessage && (
              <div>
                <h4 className="payment-method__title secondary-font" style={{ marginTop: '10px' }}>
                  <FormattedMessage id="important.information" />
                </h4>
                <span className="review-book__accept-text">
                  {parse(bookingSummary.providerMessage)}
                </span>
              </div>
            )}

              </>
            )}

            <PaymentMethod
              formRef={this.formPaymentRef as React.RefObject<FormInstance>}
              display={
                (finalBalanceDisplay > 0 && !suppressStripePaymentUI && !skipPaymentCheckout) ||
                (forceFullLegacyCard && isForceFullStripePaymentStep && finalBalance > 0) ||
                showAddressOnlyForm
              }
              addressOnly={showAddressOnlyForm}
              isRequired={isRequired}
              onChangeCountryState={() => this.setState({ isAcceptIsInsurance: false })}
              multiplePayments={this.state.multiplePayments}
              setPaymentSelected={setPaymentSelected}
              paymentSelected={paymentEffective}
              handlePaymentFormValidation={handlePaymentFormValidation}
              scrollToPaymentSelect={this.state.scrollToPaymentSelect}
              scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled}
              stripeExpressCheckoutActive={showExpressCheckoutFlow}
              hotelsStripePaymentTitle={!isVacationRentals}

              hideSavedCards={suppressStripePaymentUI}
            />

            {(!suppressStripePaymentUI ||
              this.state.forceFullStripeCheckoutPhase === 'details') && (
            <>
            {!skipPaymentCheckout && !card?.id && isCardPayment ? (
              <div className="review-book__wrapper" ref={this.insuranceContainerRef}>
                <Insurance onChange={() => this.setState({ isAcceptIsInsurance: false })} />
              </div>) : null}

            {forceFullDetailsInsurance ? (
              <div className="review-book__wrapper" ref={this.insuranceContainerRef}>
                <Insurance
                  showResidencyCountryState
                  residencyCountry={this.state.insuranceResidencyCountry}
                  residencyState={this.state.insuranceResidencyState}
                  onResidencyCountryChange={(value) =>
                    this.setState({ insuranceResidencyCountry: value })
                  }
                  onResidencyStateChange={(value) =>
                    this.setState({ insuranceResidencyState: value })
                  }
                  highlightErrors={this.state.showInsuranceResidencyErrors}
                  onResidencyStepChange={(blocked) => {
                    if (this.state.forceFullInsuranceStepBlocked !== blocked) {
                      this.setState({ forceFullInsuranceStepBlocked: blocked });
                    }
                  }}
                  onChange={() => this.setState({ isAcceptIsInsurance: false })}
                />
              </div>) : null}

            <ConfirmationEmail
              formRef={this.formEmailRef as React.RefObject<FormInstance>}
              value={this.mainGuestData('email')}
              handleEmailFormValidation={handleEmailFormValidation}
              ifEmailChanging={this.state.ifEmailChanging}
            />

            <CancellationPolicies
              displayCheckbox={true}
              disable={loadingBooking}
              checked={this.state.isAcceptCancellationPolicy}
              onChangeAcceptPolicy={this.onChangeAcceptCancellationPolicy}
            />

            <div className="review-book__wrapper">
              <Checkbox checked={this.state.isAccept} onChange={this.onChangeAccept} disabled={loadingBooking} />
              <p className="review-book__accept-text">
                <FormattedMessage
                  id="accept.you.will.be.charged"
                  values={{
                    price: renderNumber(finalBalanceDisplay + insuranceBalance, TWO),
                    type: <FormattedMessage id="hotel" />,
                    reservation_name:
                      !isEmpty(chargeDescription) && bookingSummary?.customProvider ? (
                        chargeDescription
                      ) : (
                        <FormattedMessage id="accept.you.will.be.charged.travcoding" />
                      ),
                    currency: currency,
                  }}
                />
              </p>
            </div>

            <div className="review-book__wrapper">
              <Checkbox checked={this.state.isAcceptNoChangesAllowed} onChange={this.onChangeAcceptKnowBeforeYouGo} disabled={loadingBooking} />
              <p className="review-book__accept-text">
                <FormattedMessage id="accetp.no.changes.allow" />
              </p>
            </div>

            <div className="review-book__wrapper">
              <Checkbox checked={this.state.isAcceptBookingRemarks} onChange={this.onChangeAcceptBookingRemarks} disabled={loadingBooking} />
              <p className="review-book__accept-text">
                <FormattedMessage id="by.checking.this.box.you.acknowledge.that.you.have.read" />
              </p>
            </div>

            {isPackage && account?.isTravelAgentPro && (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isAcceptIsPackage} onChange={this.onChangeAcceptIsPackage} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  <FormattedMessage id="checkout.package.message" />
                </p>
              </div>
            )}

            {hasClientCash && isLogged && (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isClientCash} onChange={this.onChangeAcceptClientCash} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  {!walletIsExternal ? (
                    <FormattedMessage
                      id={
                        effectiveClientCashPercentage > 0
                          ? 'wallet.client.cash.by.checking.acknowledge'
                          : 'wallet.client.cash.by.checking.acknowledge.no_earnings'
                      }
                      values={{
                        clientCash,
                        reward: walletNoDecimals
                          ? Math.floor(eligibleClientCash).toFixed(0)
                          : eligibleClientCash.toFixed(2),
                        clientCashPercentage: effectiveClientCashPercentage,
                        clientCashName: account?.walletClientCashName,
                      }}
                    />
                  ) : (
                    <FormattedMessage
                      id="wallet.client.cash.by.checking.acknowledge.external"
                      values={{ clientCash, clientCashName: account?.walletClientCashName }}
                    />
                  )}
                </p>
              </div>
            )}

            {!walletSkipNonRefundable &&
              !walletIsExternal &&
              hasClientCash &&
              isLogged &&
              selectedHotelReviewClientCash > 0 && (
                <div className="review-book__wrapper">
                  <Checkbox
                    checked={this.state.isClientCashNotRefundable}
                    onChange={this.onChangeAcceptClientCashNotRefundable}
                    disabled={loadingBooking}
                  />
                  <p className="review-book__accept-text">
                    <FormattedMessage
                      id="wallet.client.not_refundable.acknowledge"
                      values={{ clientCash, clientCashName: account?.walletClientCashName }}
                    />
                  </p>

                  <ModalMessage
                    text={intl.formatMessage(
                      { id: 'wallet.client.not_refundable.modal.acknowledge' },
                      { clientCashName: account?.walletClientCashName },
                    )}
                    disableTextLocalization
                    disableTitleLocalization={true}
                    visible={showNotRefundableMessage}
                    onCancel={() => this.setState({ showNotRefundableMessage: false })}
                  />
                </div>
              )}

            {account?.enableWalletReward && isLogged && (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isReward} onChange={this.onChangeAcceptReward} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  {rewardId ? (
                    <FormattedMessage
                      id="wallet.reward.by.checking.acknowledge"
                      values={{
                        rewardFormatted: `${getCurrencyText(currency)}${renderNumber((userWalletReward?.allRewards ?? []).find((r) => r.rewardId === rewardId)?.rewardValue ?? 0, 2)}`,
                        maxRewardFormatted: `${getCurrencyText(currency)}${renderNumber(bookingSummary?.bookingCard?.package?.maxRewardWalletAmount ?? 0, 2)}`,
                      }}
                    />
                  ) : (
                    <FormattedMessage id="wallet.reward.by.checking.acknowledge.not_using" />
                  )}
                </p>
              </div>
            )}

            {isInsuranceSelected ? (
              <div className="review-book__wrapper">
                <Checkbox checked={this.state.isAcceptIsInsurance} onChange={this.onChangeAcceptIsInsurance} disabled={loadingBooking} />
                <p className="review-book__accept-text">
                  <FormattedMessage id="insurance.policy.disclaimer" />
                </p>
              </div>
            ) : null}

            {hasClientCash && !isLogged && effectiveClientCashPercentage > 0 && (
              <div className="review-book__wrapper client-cash-message">
                <p className="review-book__accept-text">
                  <FontAwesomeIcon icon={faTriangleExclamation} />{' '}
                  <FormattedMessage
                    id="wallet.client.not_logged.acknowledge"
                    values={{
                      reward: eligibleClientCash.toFixed(2),
                      currency: currency,
                      clientCashPercentage: effectiveClientCashPercentage,
                      clientCashName: account?.walletClientCashName,
                    }}
                  />
                </p>
                <p
                  className="booking-confirmed__contact-property"
                  style={{ fontSize: '18px', marginTop: '10px', textAlign: 'right' }}
                >
                  <BlueButton onClick={this.hangleGoToLogin}>
                    <FormattedMessage id="sign.in" />
                  </BlueButton>{' '}
                  <FormattedMessage id="or" />{' '}
                  <BlueButton onClick={this.hangleGoToSignUp}>
                    <FormattedMessage id="sign.up" />
                  </BlueButton>
                </p>
              </div>
            )}
            </>
            )}

            {(!suppressStripePaymentUI ||
              this.state.forceFullStripeCheckoutPhase === 'details') && (
            <div
              className={`review-book__wrapper ${isOtherPayment || suppressStripePaymentUI ? 'others-methods' : 'booking-complete'}`}
            >
              <p className="review-book__agree-navigation-text">
                {bookingSummary?.showExtraPolicies && (
                  <FormattedMessage
                    id="agree.booking.expp"
                    values={{
                      pp: (msg: React.ReactNode[]) => {
                        return (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.travcoding.com/privacy-policy/"
                            onClick={() => {
                              ReactGA.event({
                                category: account?.name ?? '',
                                action: `${C_PP}_${(account?.name ?? '').toUpperCase()}`,
                                label: `User clicked privacy policy on book`,
                                nonInteraction: false,
                              });
                            }}
                          >
                            {msg}
                          </a>
                        );
                      },
                      tu: (msg: React.ReactNode[]) => {
                        return (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.travcoding.com/terms-of-use/"
                            onClick={() => {
                              ReactGA.event({
                                category: account?.name ?? '',
                                action: `${C_TERMS}_${(account?.name ?? '').toUpperCase()}`,
                                label: `User clicked terms of use on book`,
                                nonInteraction: false,
                              });
                            }}
                          >
                            {msg}
                          </a>
                        );
                      },
                      b: (msg: React.ReactNode[]) => (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://developer.expediapartnersolutions.com/terms/en"
                        >
                          {msg}
                        </a>
                      ),
                      c: (msg: React.ReactNode[]) => (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://developer.expediapartnersolutions.com/terms/agent/en/"
                        >
                          {msg}
                        </a>
                      ),
                    }}
                  />
                )}
                {!bookingSummary?.showExtraPolicies && (
                  <FormattedMessage
                    id={`${true ? 'agree.booking' : 'agree.booking.methods'
                      }`}
                    values={{
                      pp: (msg: React.ReactNode[]) => (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.travcoding.com/privacy-policy/"
                          onClick={() => {
                            ReactGA.event({
                              category: account?.name ?? '',
                              action: `${C_PP}_${(account?.name ?? '').toUpperCase()}`,
                              label: `User clicked privacy policy on book`,
                              nonInteraction: false,
                            });
                          }}
                        >
                          {msg}
                        </a>
                      ),
                      tu: (msg: React.ReactNode[]) => (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.travcoding.com/terms-of-use/"
                          onClick={() => {
                            ReactGA.event({
                              category: account?.name ?? '',
                              action: `${C_TERMS}_${(account?.name ?? '').toUpperCase()}`,
                              label: `User clicked terms of use on book`,
                              nonInteraction: false,
                            });
                          }}
                        >
                          {msg}
                        </a>
                      ),
                    }}
                  />
                )}
              </p>
            </div>
            )}

            <div
              className={`review-book__wrapper ${isOtherPayment || suppressStripePaymentUI ? 'others-methods' : 'booking-complete'}${
                suppressStripePaymentUI ? ' stripe-checkout-force-full-active' : ''
              }`}
            >
              <div
                className={[
                  'review-book__complete-btn',
                  isOtherPayment || suppressStripePaymentUI ? 'others-methods' : '',
                  suppressStripePaymentUI ? 'force-stripe-full-checkout' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <>
                  {suppressStripePaymentUI &&
                    this.state.forceFullStripeCheckoutPhase === 'details' && (
                    <div className="stripe-force-full-next">
                      <BlueButton
                        onClick={() => {
                          // The billing region used to be overwritten here with the insurance
                          // residency and then locked, because the details page had no address
                          // form of its own to fill `card`. It has one now, and the two are
                          // deliberately independent — the guest can live in one state and pay with
                          // a card billed to another — so the address carries over untouched.
                          this.setState({ forceFullStripeCheckoutPhase: 'payment' });
                        }}
                        disabled={isCardCompleteBookingDisabled}
                      >
                        <FormattedMessage id="review.book.checkout.next" />
                      </BlueButton>
                    </div>
                  )}
                  {suppressStripePaymentUI && isForceFullStripePaymentStep && !forceFullLegacyCard && (
                    <ForceFullStripeCheckout
                      type={StripeBtnTypes.Hotel}
                      amount={finalAmount}
                      currency={account?.currency}
                      totalPrice={finalAmount}
                      isDisabled={isCardCompleteBookingDisabled}
                      forceFullStripeBack={{
                        onClick: this.handleForceFullBackToDetails,
                        disabled: loadingBooking || stripeLoading,
                      }}
                    />
                  )}
                  {suppressStripePaymentUI && isForceFullStripePaymentStep && forceFullLegacyCard && (
                    <div className="force-full-legacy-card">
                      <div className="force-full-stripe-checkout__action force-full-stripe-checkout__action--card">
                        <WhiteButton
                          htmlType="button"
                          className="force-full-stripe-checkout__back"
                          onClick={this.handleForceFullBackToDetails}
                          disabled={loadingBooking}
                        >
                          <FormattedMessage id="review.book.checkout.back" />
                        </WhiteButton>
                        <BlueButton
                          className="force-full-stripe-checkout__complete"
                          onClick={this.handleOnCompleteBooking}
                          disabled={isCardCompleteBookingDisabled}
                        >
                          <FormattedMessage id="complete.booking" />
                          {loadingBooking && <Spin />}
                        </BlueButton>
                      </div>
                    </div>
                  )}
                    
                  {!suppressStripePaymentUI && shouldMountStripeExpressElements && (
                    <div
                      style={
                        !this.state.expressWalletProbeComplete
                          ? STRIPE_EXPRESS_PROBE_SR_ONLY
                          : { display: isOtherPayment ? '' : 'none' }
                      }
                    >
                      <Elements
                        stripe={stripePromise}
                        options={{
                          mode: 'payment',
                          // Must match the BFF PaymentIntent (manual capture). Capture happens after the
                          // provider booking succeeds; on failure the authorization is voided (no refund).
                          captureMethod: 'manual',
                          amount: finalAmount,
                          currency: (account?.currency ?? 'usd').toLowerCase(),
                        }}
                      >
                        <ExpressCheckoutButtons
                          totalPrice={finalAmount}
                          formsRef={{ formEmail: this.formEmailRef, formGuest: this.formGuestRef }}
                          onExpressWalletAvailabilityResolved={this.onExpressWalletAvailabilityResolved}
                          isDisabled={isCardCompleteBookingDisabled}
                          type={StripeBtnTypes.Hotel}
                          setMultiplePayments={setMultiplePayments}
                          paymentSelected={this.state.paymentSelected}
                        />
                      </Elements>
                    </div>)}

                  {!suppressStripePaymentUI && showCompleteBookingButton && (
                    <BlueButton
                      onClick={this.handleOnCompleteBooking}
                      disabled={isCardCompleteBookingDisabled}
                    >
                      <FormattedMessage id="complete.booking" />
                      {loadingBooking && <Spin />}
                    </BlueButton>)}
                </>
              </div>
            </div>

            {showRequiredFieldsMessage
              && <p className='payment-complete-fields'>Please, fill in all required fields to proceed {' '}
                <u onClick={validateForm} style={{ cursor: 'pointer' }}>(View Fields)</u></p>}

            {(showInsuranceGuestSection || forceFullDetailsInsurance) && (
              <InsuranceRequiredMessage
                display={
                  ((isInsuranceSelectionMissing || forceFullInsuranceBlocksNext) &&
                    (!suppressStripePaymentUI ||
                      this.state.forceFullStripeCheckoutPhase === 'details')) as boolean
                }
                insuranceContainerRef={this.insuranceContainerRef as React.RefObject<HTMLDivElement>}
                classNameContainer="review-book__wrapper"
              />)}
          </div>
          )}

          {isBookingInProgress && <ReservationProgress isBookingInProgress={isBookingInProgress} />}

          <BookingConfirmed
            isBookingComplete={bookingComplete}
            isVacationRentals={isVacationRentals}
            packageData={reviewBookStore}
          />

          <ModalConfirmation
            message="non.refundable.reservation.message"
            title="non.refundable.reservation"
            yesMessage="yes"
            noMessage="no"
            visible={this.state.showNotRefundableConfirmModal}
            onCancel={() => this.setState({ showNotRefundableConfirmModal: false })}
            onConfirm={() =>
              this.setState({ showNotRefundableConfirmModal: false }, this.onCompleteBooking)
            }
          />

          <ModalConfirmation
            message="insurance.payment.switch.message"
            title="insurance.payment.switch.title"
            yesMessage="insurance.payment.switch.continue"
            noMessage="insurance.payment.switch.keep"
            visible={!!this.state.pendingPaymentSwitch}
            onCancel={() => this.setState({ pendingPaymentSwitch: null })}
            onConfirm={() => {
              const nextPayment = this.state.pendingPaymentSwitch as string;
              this.props.setInsuranceSelection(InsuranceSelection.NO);
              this.setState({
                pendingPaymentSwitch: null,
                paymentSelected: nextPayment,
                isAcceptIsInsurance: false,
              });
            }}
          />

          {isPriceChangedError && (
            <BookingFailed
              title={intl.formatMessage({ id: 'price.changed' })}
              description={intl.formatMessage({ id: 'unable.to.confirm.booking' })}
              buttonTitle={intl.formatMessage({ id: 'book.another.room' })}
              onClick={this.redirectToHotelPage}
              isPriceChangedError={isPriceChangedError}
              isVacationRentals={isVacationRentals}
            />)}

          {isSoldOutError && (
            <BookingFailed
              title={this.titleBookingFailed()}
              isVacationRentals={isVacationRentals}
              description={intl.formatMessage({ id: 'sorry.we.were.unable.to.confirm' })}
              buttonTitle={intl.formatMessage({ id: 'start.searching' })}
              onClick={this.redirectToHotelPage}
            />)}

          {!certificateApplied && <ReviewBookPriceChangeModal isVacationRentals={isVacationRentals} />}
          <AvailabilityStatusModal isVacationRentals={isVacationRentals} certificateApplied={certificateApplied} />
          <ThreeDSModal />

          {threeDSLoading ? (
            <div className="review-book__loading-container">
              <Loading />
            </div>) : null}

          {isSessionExpired && (
            <div className="result-wrapper__expired-message">
              <ExpiredSessionModal
                visible={isSessionExpired}
                hasRedirect={true}
                onHandleRedirect={this.handleRedirect}
              />
            </div>
          )}
          <GlobalLoading isVisible={stripeLoading} />
        </>
      )
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    redeemCodeStore: state.redeemCodeStore,
    marginatorStore: state.marginatorStore,
    hotelsStore: state.hotelsStore,
    filtersStore: state.filtersStore,
    loginStore: state.loginStore,
    insuranceStore: state.insuranceStore,
    certificatesStore: state.certificatesStore,
    navigationMenuStore: state.navigationMenuStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getBookPackageWithCard,
  setGuests,
  setPriceChangedError,
  getNavigationMenu,
  setLoginRedirect,
  setInsuranceSelection: insuranceActions.setSelection,
  setCard,
  refreshInsuranceQuote,
  resetInsurance: insuranceActions.reset,
};

export const ReviewBook = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(ReviewBookComponent)));

